<template>
    <div>
        <BayarGaji v-if="isbayargaji" v-on:backtolistpenggajian="showlistpenggajian" v-on:gotofakturgaji="showfakturgajipenggajian"
                   v-bind:databayargaji="databayargaji" />
        <FakturGaji v-if="isfakturgaji" v-on:goshowhistory="goshowhistory" v-on:backtobayargaji="showbayargaji" v-bind:databayargaji="databayargaji"
                    v-on:gotopreview="showpreviewgajipenggajian" v-bind:datafakturgaji="datafakturgaji"
                    v-on:gotodetailkehadiran="showdetailkehadiranAbsensi" v-bind:datadetailabsen="datadetailkehadiran"
                    ref="Fakturgaji"/>
        <PreviewGaji v-if="ispreviewgaji" v-bind:datapreviewgaji="datapreviegaji"
                     v-on:backtofaktur="showfakturgajipenggajian"/>
        <DetailKehadiran v-if="isdetailkehadiran" v-on:backtofaktur="showfakturGajifromdetailkehadiranAbsensi"
                         v-bind:datafakturgaji="datafakturgaji" v-bind:datadetailabsen="datadetailkehadiran"
                         v-on:gotoUbah_Absensi="showUbahAbsensi"/>

        <UbahAbsensi v-if="isubahABsensi" v-on:backtodetailkehadiran="showdetailkehadiranAbsensi"
                     v-bind:datafakturgaji="datafakturgaji" v-bind:databayargaji="databayargaji"
                     v-on:detailAbsenPenggajian="showDetailAbsensiPenggajian"/>
        <DetailAbsenPenggajian v-if="isdetailAbsenPenggajian" v-on:showubahabsensi="showUbahAbsensi" :datarekapdetail="datadetailabsenpenggajian"/>
    </div>
</template>

<script>
    import BayarGaji from "./penggajian/Faktur Gaji/BayarGaji";
    import FakturGaji from "./penggajian/Faktur Gaji/FakturGaji";
    import PreviewGaji from "./penggajian/Faktur Gaji/PreviewGaji";
    import DetailKehadiran from "./penggajian/Faktur Gaji/DetailKehadiran";
    import UbahAbsensi from "./penggajian/Faktur Gaji/UbahAbsensi";
    import DetailAbsenPenggajian from "./penggajian/Faktur Gaji/DetailAbsenPenggajian";
    export default {
        name: "AddFakturGaji",
        components:{DetailAbsenPenggajian, UbahAbsensi, DetailKehadiran, FakturGaji, BayarGaji,PreviewGaji},
        data(){
            return{
                isbayargaji:false,
                isfakturgaji:false,
                ispreviewgaji:false,
                isdetailkehadiran:false,
                isubahABsensi:false,
                isdetailAbsenPenggajian:false,


                databayargaji:{
                    karyawan:[],
                    selected_karyawan_Faktur:'',
                    input_date_awal_Faktur:'',
                    input_date_akhir_Faktur:'',
                    Check_Karyawan:[],
                    status_periode_Faktur:0,
                },

                datafakturgaji:{
                    AbsensiFaktur:[],
                    masuk_kerja_Faktur:0,
                    nama_karyawan_Faktur:'',
                    periode_format_Faktur:'',
                    Alpha_Faktur:'',
                    nominal_tanggungan_fix:0,
                },

                datapreviegaji:{

                },

                datadetailkehadiran:{
                    masuk_kerja_kehadiran:0,
                    alpha_Kehadiran:0,
                    Sakit_Kehadiran:0,
                    Cuti_Kehadiran:0,
                    TanpaStatus_Kehadiran:0,
                    arraydatahadir:[],
                    durasi_keterlambatan:{
                        formatted:"",
                        raw:0
                    },
                    type_waktu:'',
                    nominal_keterlambatan:{
                        formatted:"",
                        raw:0
                    },
                },

                dataubahAbsensi:{
                    Periode_UbahAbsen:'',
                },

                datadetailabsenpenggajian:{

                },

                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            this.showbayargaji();
        },
        methods:{
            showbayargaji(){
                this.isbayargaji=true;
                this.isfakturgaji=false;
                this.ispreviewgaji =false;
                this.isubahABsensi =false;
            },


            showlistpenggajian(){
                this.$emit('showlistpenggajian')
            },

            goshowhistory(){
                this.$emit('showhistory')
            },


            showfakturgajipenggajian(){
                this.AbsenKaryawanFaktur();
                this.isbayargaji=false;
                this.isfakturgaji=true;
                this.ispreviewgaji =false;
                this.isdetailkehadiran = false;
                this.isubahABsensi =false;
                this.isdetailAbsenPenggajian = false
            },


            showpreviewgajipenggajian(){
                this.isbayargaji=false;
                this.isfakturgaji=false;
                this.ispreviewgaji =true;
                this.isdetailkehadiran = false;
                this.isubahABsensi =false;
                this.isdetailAbsenPenggajian = false
            },

            showdetailkehadiranAbsensi(){
                this.AbsenKaryawanFaktur();
                this.isbayargaji=false;
                this.isfakturgaji=true;
                this.ispreviewgaji =false;
                this.isdetailkehadiran = true;
                this.isubahABsensi =false;
                this.isdetailAbsenPenggajian = false
                $('#FakturGaji').hide();
            },

            showfakturGajifromdetailkehadiranAbsensi(){
                this.AbsenKaryawanFaktur();
                this.isbayargaji=false;
                this.isfakturgaji=true;
                this.ispreviewgaji =false;
                this.isdetailkehadiran = false;
                this.isubahABsensi =false;
                this.isdetailAbsenPenggajian = false;

                $('#FakturGaji').show();
            },

            showUbahAbsensi(){
                this.AbsenKaryawanFaktur();
                this.isbayargaji=false;
                this.isfakturgaji=true;
                this.ispreviewgaji =false;
                this.isdetailkehadiran = false;
                this.isubahABsensi = true;
                this.isdetailAbsenPenggajian = false
                $('#FakturGaji').hide();
            },

            showDetailAbsensiPenggajian(dataAbsen){
                this.datadetailabsenpenggajian=dataAbsen
                // this.AbsenKaryawanFaktur();
                this.isbayargaji=false;
                this.isfakturgaji=true;
                this.ispreviewgaji =false;
                this.isdetailkehadiran = false;
                this.isubahABsensi = false;
                this.isdetailAbsenPenggajian = true;
                $('#FakturGaji').hide();
            },


            async AbsenKaryawanFaktur(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                this.datafakturgaji.AbsensiFaktur=[];
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/meta_absensi_faktur?idkaryawan='
                        + this.databayargaji.selected_karyawan_Faktur + '&tanggal_mulai=' + this.databayargaji.input_date_awal_Faktur
                        + '&tanggal_selesai=' + this.databayargaji.input_date_akhir_Faktur, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var DataKaryawanABsen = response.data.data;
                        var DataRekapabsen = response.data.data.rekapabsen;
                        this.datafakturgaji.nama_karyawan_Faktur = DataKaryawanABsen.nama_karyawan;
                        this.datafakturgaji.periode_format_Faktur = DataKaryawanABsen.periode_format;
                        this.datafakturgaji.masuk_kerja_Faktur = DataKaryawanABsen.masuk_kerja;
                        this.datafakturgaji.Alpha_Faktur = DataKaryawanABsen.tidak_masuk_kerja;
                        this.datadetailkehadiran.masuk_kerja_kehadiran = DataKaryawanABsen.masuk_kerja;
                        this.datadetailkehadiran.alpha_Kehadiran = DataKaryawanABsen.alpha;
                        this.datadetailkehadiran.Sakit_Kehadiran = DataKaryawanABsen.sakit;
                        this.datadetailkehadiran.Cuti_Kehadiran = DataKaryawanABsen.cuti;
                        this.datadetailkehadiran.TanpaStatus_Kehadiran = DataKaryawanABsen.tanpa_status;
                        this.dataubahAbsensi.Periode_UbahAbsen = DataKaryawanABsen.periode_format;
                        for (var i = 0; i < DataRekapabsen.length; i++) {
                            this.datafakturgaji.AbsensiFaktur.push({
                                tanggal: DataRekapabsen[i].tanggal,
                                status: DataRekapabsen[i].status,
                                waktu:DataRekapabsen[i].waktu,
                                idkaryawan:DataRekapabsen[i].idkaryawan,
                                tanggal_format:DataRekapabsen[i].tanggal_format,
                                // idlokasi:DataRekapabsen[i].Idlokasi,
                            })
                        }
                    }
                }catch (e) {
                    if (!e.code) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#alert').show()
                        $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                        $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                        setTimeout(() => {
                            $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                            $('#alert').addClass("alert alert-danger animated fadeOutUp");
                            setTimeout(() =>{
                                $('#alert').addClass("display-none")
                            },2000)
                        }, 30000)
                        if (e.response.status === 500) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#alert').show()
                            $('#contentAlert').text(e.response.data.msg);
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                            $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                            setTimeout(() => {
                                $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                                $('#alert').addClass("alert alert-danger animated fadeOutUp");
                                setTimeout(() =>{
                                    $('#alert').addClass("display-none")
                                },2000)
                            }, 30000)
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>